/* D-GIRI 18/10/2026. Page «Giri», catalogue: images get their real srcset when the entry is 400 px from view; the filter bar shows the
   entries of one round and one state, switches between the grid of plates and the list of cards, and says how many entries are in view. */
(() => {
  const imgs = document.querySelectorAll('.bhd-g img[data-na-srcset]');
  const vai = (i) => { i.srcset = i.dataset.naSrcset; i.src = i.dataset.naSrc; i.removeAttribute('data-na-srcset'); };
  if (!('IntersectionObserver' in window)) imgs.forEach(vai);
  else {
    const o = new IntersectionObserver((voci) => { for (const v of voci) if (v.isIntersecting) { vai(v.target); o.unobserve(v.target); } }, { rootMargin: '400px 0px' });
    imgs.forEach((i) => o.observe(i));
  }
  const bar = document.querySelector('.bhd-g-filtro');
  if (!bar) return;
  const schede = [...document.querySelectorAll('.bhd-g-scheda')];
  const conta = bar.querySelector('[data-conta]');
  const nessuna = bar.querySelector('.bhd-g-filtro__nessuna');
  const st = { giro: '', stato: '' };
  const applica = () => {
    let n = 0;
    for (const s of schede) {
      const ok = (!st.giro || s.dataset.giro === st.giro) && (!st.stato || s.dataset.stato === st.stato);
      s.hidden = !ok; if (ok) n++;
    }
    for (const g of document.querySelectorAll('.bhd-g-gruppo')) g.hidden = !g.querySelector('.bhd-g-scheda:not([hidden])');
    for (const g of document.querySelectorAll('.bhd-g-giro')) g.hidden = !g.querySelector('.bhd-g-scheda:not([hidden])');
    conta.textContent = n;
    nessuna.hidden = n > 0;
  };
  bar.addEventListener('click', (e) => {
    const b = e.target.closest('button[data-f]');
    if (!b) return;
    const f = b.dataset.f;
    bar.querySelectorAll(`button[data-f="${f}"]`).forEach((x) => x.setAttribute('aria-pressed', x === b ? 'true' : 'false'));
    if (f === 'vista') { document.documentElement.classList.toggle('bhd-schede', b.dataset.v === 'schede'); return; }
    st[f] = b.dataset.v;
    applica();
  });
  applica();
})();
